var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{staticClass:"text-center d-flex flex-column stat-card"},[_c('v-card-text',[_c('v-icon',{attrs:{"color":_vm.color,"size":"36"}},[_vm._v(_vm._s(_vm.icon))]),_c('h3',{staticClass:"headline font-weight-bold mt-2"},[_vm._v(_vm._s(_vm.value))]),_c('div',{staticClass:"subtitle-1"},[_vm._v(_vm._s(_vm.title))])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }